// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"a519446d","189":"72bc0de2","415":"30e3c1c3","440":"02a3c6c3","458":"d5894855","526":"2945283f","741":"28029585","852":"27f29a54"}[chunkId] + ".chunk.js";
};